import { Route } from "components/Route";
import { Switch } from "react-router-dom";
import { routes } from "routes";
import { TrackDashboardPage } from "./TrackDashboardPage";
import { TrackGroupPage } from "./TrackGroupPage";

export const TrackAndReportSwitch = (): JSX.Element => {
	return (
		<Switch>
			<Route path={routes._.trackAndReport._.trackGroup.path}>
				<TrackGroupPage />
			</Route>

			<Route exact path={routes._.trackAndReport.path}>
				<TrackDashboardPage />
			</Route>
		</Switch>
	);
};
